import * as Sentry from '@sentry/react';
import './initSentry';

import './initPolyfills';

import '@raison/ui-kit/styles';
import './initBigNumber';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {FallbackPage} from '~/entities/fallbacks';
import {initBiometry} from '~/entities/user';
import {env} from '~/environment';
import appLoadTimeStatistic from '~/shared/api/legacy_services/appLoadTimeStatistic';
import {ExtendedWindow, OneSignalInfo} from '~/shared/api/legacy_services/oneSignalService';

import {ShellVersion} from '~/entities/versions';
import {Application} from './Application';
import './index.css';

main();

async function main() {
    ShellVersion.registerDescriptor();

    if (import.meta.env.DEV) {
        if (typeof import.meta.env.VITE_MOCK_API === 'string') {
            const {initMsw} = await import('./initMsw');
            await initMsw(import.meta.env.VITE_MOCK_API, env.API_URL);
        }
    }

    initBiometry();
    initOneSignal();
    appLoadTimeStatistic.initialize();
    renderApp();
}

async function renderApp() {
    const container = document.querySelector('#application');
    if (!container) {
        throw new Error('No #application element');
    }
    ReactDOM.createRoot(container).render(
        <Sentry.ErrorBoundary fallback={<FallbackPage />}>
            <ShellVersion.Gate>
                <Application />
            </ShellVersion.Gate>
        </Sentry.ErrorBoundary>
    );
}

function initOneSignal() {
    /**
     * Receive oneSignal info object through gonative integration.
     * @param oneSignalInfo is an object which received from oneSignal
     * @description Links:
     * @description Gonative docs - {@link https://gonative.readme.io/docs/associating-users-and-devices}
     * @description Inversion of control - {@link https://en.wikipedia.org/wiki/Inversion_of_control}
     */
    function gonative_onesignal_info(oneSignalInfo: OneSignalInfo) {
        (window as unknown as ExtendedWindow).oneSignalInfo = oneSignalInfo;
    }
    // TODO: interact with gonative through promises
    (window as unknown as ExtendedWindow).gonative_onesignal_info = gonative_onesignal_info;
}
